// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ArticleLoader from './ArticleLoader';
import ImageCard from 'components/ImageCard/ImageCard';

export default class ArticlePreview extends PureComponent {
  static propTypes = {
    author: PropTypes.string,
    description: PropTypes.string,
    fetchArticleOpenGraph: PropTypes.func.isRequired,
    image: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string
  };

  static defaultProps = {
    author: null,
    image: null,
    title: null,
    url: null
  };

  componentWillMount() {
    const { fetchArticleOpenGraph, url } = this.props;
    fetchArticleOpenGraph(url);
  }

  trackClick = () => {
    const { onClick, publisher, title, url } = this.props;

    onClick({ publisher, title, url });
  };

  render() {
    const { fetched, image, publisher, title, url } = this.props;
    if (!publisher || !image || !title || !url) {
      if (!fetched) return <ArticleLoader {...this.props} />;
      return null;
    }

    return (
      <ImageCard
        description={publisher}
        imageUrl={image}
        onClick={this.trackClick}
        title={title}
        url={url}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticlePreview/ArticlePreview.js